<template>
  <div
    :style="{'background-image':'url('+store.ProfileImage+')'}"
    class="banner-header text-white position-relative"
  >
    <div class="company-details">
      <img alt="logo" :src="store.Logo" />
      <h2 v-show="store.StoreTitle">{{ store.StoreTitle }}</h2>
      <h5>{{ store.DisplayName }}</h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopHeader",
  props: {
    store: {
      type: Object,
      default: function() {
        return null;
      }
    }
  }
};
</script>
